'use client';

export { Geiger, playGeigerClickSound } from 'react-geiger';
import GeigerDefault from 'react-geiger';
export default GeigerDefault;
